<template>
  <div class="waiting">
    <Navbar />
    <div>
      <b-container>
        <b-row class="container">
          <div class="text">
            Nenhuma transmissão
            <br />no momento...
            <br />Volte mais tarde.
          </div>
          <img class="img" src="@/assets/Aguardar-ao-vivo/wait-live.png" />
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar-user";
export default {
  components: {
    Navbar
  }
};
</script>

<style lang="scss" scoped>
.waiting {
  font-family: Roboto;
  background-color: #000000;
  height: 100vh;
}
.container {
  width: 100vw;
  height: 75vh;
  background-color: #000000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
}
.text {
  color: #ffffff;
  font-size: 38px;
  padding-right: 3%;
}
.img {
  width: 50%;
  padding-left: 3%;
}
@media screen and (max-width: 768px) {
  .text {
    font-size: 25px;
    padding: 0px;
  }
  .img {
    width: 90%;
    margin: 0 auto;
    padding: 0px;
  }
}
</style>
